import { copyArray } from "./MisFieldFilter/helper";

export const setAppliedfilters = (filterList) => {
    let tempFilterList = [];
    filterList.forEach(data => {
        if (data.value) {
            tempFilterList.push(data)
        }
    })
    return tempFilterList
}

export const removeFilterValue = (index, filterList) => {
    const tempFilterList = copyArray(filterList);
    tempFilterList.splice(index, 1)
    return tempFilterList
}

export const removeAppliedFilterData = (filterData, filterList) => {
    const tempFilterList = copyArray(filterList);
    for (let i = 0; filterList.length; i++) {
        if (filterData.label === filterList[i].label) {
            tempFilterList[i].value = false;
            break;
        }
    }
    return tempFilterList
}

export const clearAllFilter = (filterList) => {
    filterList.forEach(data => {
        data.value = false
    })
    return filterList
}

export const setMisFilteredRequestBody = (pageNo, pageSize, sorted, appliedFilters, searchText) => {
    let requestBody = {
        paginatedData: {
            pageNumber: pageNo,
            pageSize: pageSize,
            sortfield: sorted.id,
            sortDirection: (sorted.desc) ? 'desc' : 'asc'
        },
        requestData: {
            name: (searchText) ? searchText : '',
            keyTypes: getKeyTypeFilter(appliedFilters),
            dataTypes: getDataTypeFilter(appliedFilters),
            formCategories: getFormCategoryFilter(appliedFilters)
        }
    }
    return requestBody
}

const getKeyTypeFilter = (appliedFilters) => {
    let tempFilters = []
    appliedFilters.forEach(data => {
        if (data.type === 'keyType') {
            tempFilters.push(data.label)
        }
    })
    return tempFilters
}

const getDataTypeFilter = (appliedFilters) => {
    let tempFilters = []
    appliedFilters.forEach(data => {
        if (data.type === 'dataType') {
            tempFilters.push(data.label)
        }
    })
    return tempFilters
}

const getFormCategoryFilter = (appliedFilters) => {
    let tempFilters = []
    appliedFilters.forEach(data => {
        if (data.type === 'formCategory') {
            tempFilters.push(data.label)
        }
    })
    return tempFilters
}